export default {
  uploads: (state) => state.uploads,
  upload: (state) => state.upload,
  read: (state) => state.read,
  files: (state) => state.files,
  posts: (state) => state.posts,
  uploadsByKeywords: (state) => state.uploadsByKeywords,
  isLoading: (state) => state.isLoading
};
